// extracted by mini-css-extract-plugin
export default {"anonymousAvatar":"juLMBW","withBorder":"maMAW2","filter":"lSpjrY"};